package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_12_28_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had met a charming and somewhat mysterious family on the edge of Vor’s desert.  Caper and Falorn are troubled by some fragments of a conversation between Joral and Metha that they overheard late at night, so they confront the couple about the meaning of “Danger” and “Downplay.” Joral explains how the family came across two giant scorpions and quickly fleed, as the scorpions were much larger than a scorpion ought to be, and they appeared more aggressive too. Joral believes that the Blue Dragon he spotted was a bad omen and not just a dangerous killing machine. The heroes are satisfied with this explanation.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("While the heroes are happy to enjoy each others company without defining or labeling their relationship, the denizens of Veldekar generally find this unacceptable — Joral is no different. Joral promises the heroes that the next time he crosses their path, he will have thought up a great name from their group.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes resume their journey down the road. It’s hot but there’s a breeze coming down from the mountains toward the river. The heroes see jack rabbits, lizards, and snakes — perhaps Vor’s desert isn’t that dangerous?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes setup the tiny hut for the night.")
    }
}
